var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.58 54.882 v 31.965 c 0 1.741 1.412 3.153 3.153 3.153 h 60.534 c 1.741 0 3.153 -1.412 3.153 -3.153 V 54.882 C 56.073 47.881 33.792 47.838 11.58 54.882 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(184,53,53)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 78.42 54.882 V 18.345 C 69.386 13.658 63.133 7.61 60.075 0 H 14.733 c -1.741 0 -3.153 1.412 -3.153 3.153 v 51.729 H 78.42 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(233,233,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 78.42 18.345 H 62.948 c -1.587 0 -2.873 -1.286 -2.873 -2.873 V 0 L 78.42 18.345 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(217,215,202)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 40.211 62.995 h -3.528 c -2.197 0 -3.985 1.787 -3.985 3.984 V 77.98 c 0 2.197 1.787 3.984 3.985 3.984 h 3.528 c 2.197 0 3.985 -1.787 3.985 -3.984 V 66.979 C 44.196 64.782 42.408 62.995 40.211 62.995 z M 41.091 77.98 c 0 0.485 -0.395 0.879 -0.88 0.879 h -3.528 c -0.485 0 -0.88 -0.394 -0.88 -0.879 V 66.979 c 0 -0.485 0.395 -0.879 0.88 -0.879 h 3.528 c 0.486 0 0.88 0.394 0.88 0.879 V 77.98 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(249,249,249)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.796 62.995 h -5.153 c -0.858 0 -1.552 0.695 -1.552 1.552 v 15.864 c 0 0.857 0.695 1.552 1.552 1.552 h 5.153 c 2.643 0 4.792 -2.15 4.792 -4.792 v -9.386 C 29.588 65.145 27.438 62.995 24.796 62.995 z M 26.483 77.172 c 0 0.93 -0.757 1.687 -1.687 1.687 h -3.601 V 66.1 h 3.601 c 0.93 0 1.687 0.757 1.687 1.687 V 77.172 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(249,249,249)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 51.484 66.1 h 4.727 c 0.857 0 1.552 -0.695 1.552 -1.552 c 0 -0.857 -0.695 -1.552 -1.552 -1.552 h -4.727 c -2.351 0 -4.263 1.912 -4.263 4.262 v 10.445 c 0 2.35 1.912 4.262 4.263 4.262 h 4.727 c 0.857 0 1.552 -0.695 1.552 -1.552 c 0 -0.857 -0.695 -1.552 -1.552 -1.552 h -4.727 c -0.639 0 -1.158 -0.52 -1.158 -1.157 V 67.257 C 50.325 66.619 50.845 66.1 51.484 66.1 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(249,249,249)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 71.083 63.175 c -0.755 -0.398 -1.695 -0.111 -2.098 0.647 l -2.824 5.338 l -2.824 -5.338 c -0.401 -0.758 -1.339 -1.047 -2.098 -0.647 c -0.758 0.401 -1.047 1.34 -0.647 2.098 l 3.813 7.206 l -3.813 7.206 c -0.4 0.758 -0.111 1.697 0.647 2.098 c 0.231 0.122 0.479 0.18 0.725 0.18 c 0.557 0 1.095 -0.3 1.374 -0.827 l 2.824 -5.338 l 2.824 5.338 c 0.279 0.527 0.817 0.827 1.374 0.827 c 0.245 0 0.493 -0.058 0.725 -0.18 c 0.758 -0.401 1.047 -1.34 0.647 -2.098 l -3.813 -7.206 l 3.813 -7.206 C 72.13 64.515 71.841 63.576 71.083 63.175 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(249,249,249)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocx);
export default __webpack_public_path__ + "static/media/docx.0a851433bb26aaef730a848e1021c385.svg";
export { ForwardRef as ReactComponent };